// extracted by mini-css-extract-plugin
module.exports = {"tab":"CookieTabSwitcher__tab--1Om","active":"CookieTabSwitcher__active--1MK"};